var map = {
	"./de-de.json": 3839,
	"./en-xz.json": 4922,
	"./et-ee.json": 1716,
	"./fi-fi.json": 2951,
	"./i18n-dropdown.json": 1788,
	"./lt-lv.json": 3435,
	"./lv-lv.json": 2233,
	"./ru-ee.json": 232,
	"./ru-lv.json": 7044,
	"./ru-ru.json": 1415,
	"./sv-dk.json": 7067,
	"./sv-fi.json": 7927,
	"./sv-no.json": 6429,
	"./sv-se.json": 8726
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9401;